import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import {
  role,
  userRole as userRoleAPI,
  user,
  location,
  asset,
} from "../../../../api";
import { useDashboardContext } from "../../../../contexts/NewDashboardContext.jsx";
import NormalInput from "../../../../components/form/HorizontalNormalInput/index.jsx";
import NormalSelect from "../../../../components/form/HorizontalNormalSelect/index.jsx";
import PhoneInput from "react-phone-number-input";
import SignatureCanvas from "react-signature-canvas";
import Select, { StylesConfig } from "react-select";
import { isPermissionAllowed } from "../../../../components/PermissionChecker/permissionChecker";
import { PermissionChecker } from "../../../../components/PermissionChecker/index.jsx";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../components/card/card.jsx";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0, 0, 0, 0.48)",
    borderColor: "var(--bs-border-color)",
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
  }),
};

function getLeafLocationsWithPath(locations) {
  const result = [];

  function traverse(location, path) {
    const currentPath = [...path, location.location_name];

    if (!location.sublocations || location.sublocations.length === 0) {
      result.push({
        value: location.id,
        label: currentPath.join(" | "),
      });
    } else {
      location.sublocations.forEach((sublocation) =>
        traverse(sublocation, currentPath)
      );
    }
  }

  locations.forEach((location) => traverse(location, []));

  return result;
}

function ModalChangeUser({ open, onClose, onSubmit, row, customers }) {
  const sigCanvas = useRef(null);
  const { selectedApp } = useDashboardContext();
  const { allowedPermissions, username } = useAuth();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [signature, setSignature] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [userRole, setUserRole] = useState("");
  const [status, setStatus] = useState("");
  const [customer_id, setCustomerId] = useState("");
  const [userRoles, setUserRoles] = useState([]);
  const [drawer, setDrawer] = useState(false);
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const [locations, setLocations] = useState([]);
  const [assets, setAssets] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);

  function clear() {
    sigCanvas.current.clear();
  }

  function trim() {
    console.log(sigCanvas.current.getSignaturePad());
    setTrimmedDataURL(
      sigCanvas.current.getSignaturePad().toDataURL("image/png")
    );
  }
  async function getUserRole() {
    try {
      let res;
      if (selectedApp == "CGM") {
        res = await userRoleAPI.list();
      }
      if (selectedApp == "CMMS") {
        res = await role.list();
      }

      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        setUserRoles(data);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getLocation() {
    const res = await location.list("", "true");
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setLocations(data);
    }
  }

  async function getAsset() {
    const res = await asset.list();
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setAssets(
        data.map((i) => ({
          value: i.id,
          label: i.asset_name,
          location_id: i.location_id,
        }))
      );
    }
  }

  useEffect(() => {
    getUserRole();
    getLocation();
    // getAsset();
  }, []);

  function isNumeric(str) {
    if (typeof str != "string") return false; // we only process strings!
    return (
      !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ); // ...and ensure strings of whitespace fail
  }

  async function onSave() {
    //validation
    let errors = [];

    if (!row && !password) {
      errors.push("password");
    }
    if (!email) {
      errors.push("email");
    }
    if (!jobTitle) {
      errors.push("job title");
    }
    if (!firstname) {
      errors.push("first Name");
    }
    if (!lastname) {
      errors.push("last Name");
    }
    // if (!contactNumber) {
    //   errors.push("contact number");
    // } else {
    //   if (!isNumeric(contactNumber)) {
    //     toast.error("Invalid contact number");
    //     return;
    //   }
    // }
    if (!userRole) {
      errors.push("user role");
    }
    if (status === "") {
      errors.push("status");
    }
    if (errors.length > 0) {
      toast.error("The " + errors.join(", ") + " must not be empty");
      return;
    }

    console.log(selectedLocations);

    onSubmit({
      password,
      signature,
      email,
      firstname,
      customer_id,
      lastname,
      trimmedDataURL,
      phone,
      jobTitle,
      contactNumber,
      userRole,
      status,
      locations: [...selectedLocations],
    });
    clearFields();
  }

  function clearFields() {
    setPassword("");
    setEmail("");
    setJobTitle("");
    setFirstname("");
    setLastname("");
    setCustomerId("");
    setPhone("");
    setContactNumber("");
    setUserRole("");
    setStatus(1);
    setSelectedLocations([]);
  }
  async function handleClose() {
    clearFields();
    onClose();
  }
  function handleRoleChange(e) {
    const value = e.target.value;
    //console.log("selrole", value);
    setUserRole(value);
  }
  function handleCustomerChange(e) {
    const value = e.target.value;
    setCustomerId(value);
  }
  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
  };
  useEffect(() => {}, []);

  useEffect(() => {
    if (row) {
      setPassword("");
      setEmail(row.email);
      setJobTitle(row.job_title);
      setFirstname(row.firstname);
      setCustomerId(row.customer_id);
      setPhone(row.phone);
      const imgg = renderImage(`/machine/attachment/${row.signature}`);
      if (row.signature) {
        setSignature(imgg);
      } else {
        setSignature(null);
      }

      setLastname(row.lastname);
      setContactNumber(row.contact_number);
      if (selectedApp == "CMMS") {
        if (row.companies[0].cmms_role?.id) {
          setUserRole(row.companies[0].cmms_role?.id);
        }
      }

      if (selectedApp == "CGM") {
        if (row.companies[0].role?.id) {
          setUserRole(row.companies[0].role?.id);
        }
      }

      setStatus(row.is_active == true ? 1 : 0);
      setSelectedLocations(
        row.assigned_locations.map((location) => location.location_id)
      );
    } else {
      clearFields();
    }
  }, [row]);

  async function confirmSignature() {
    if (!trimmedDataURL) {
      toast.error("Please draw and trim your signature");
      return;
    }
    try {
      setSignature(trimmedDataURL);
      setDrawer(false);
    } catch (e) {
      toast.error(e.message);
    }
  }

  const handleSelectLocation = (id) => {
    if (selectedLocations.includes(id)) {
      setSelectedLocations((values) => values.filter((v) => v !== id));
    } else {
      setSelectedLocations((values) => [...values, id]);
    }
  };

  const isSelectedLocation = (id) => {
    return selectedLocations.includes(id);
  };
  let level = 0;
  const renderLocations = (locations, level) => {
    level++;
    return (
      <>
        {locations.map((location, index) => {
          return (
            <div key={index}>
              <div
                className="form-check"
                onClick={() => handleSelectLocation(location.id)}
              >
                <input
                  className="form-check-input"
                  checked={isSelectedLocation(location.id)}
                  type="checkbox"
                  id={`${location.id}`}
                />
                <label className="form-check-label" htmlFor={location.id}>
                  {location.location_name}
                </label>
              </div>
              {level < 3 &&
                location.sublocations &&
                location.sublocations.length > 0 && (
                  <div style={{ marginLeft: "20px" }}>
                    {renderLocations(location.sublocations)}
                  </div>
                )}
            </div>
          );
        })}
      </>
    );
  };

  // const handleChangeLocation = (e) => {
  //   setSelectedLocation(e);
  //   if (e.length > 0) {
  //     const location_id = e.map((f) => f.value);
  //     setFilteredAssets(
  //       assets.filter((a) => location_id.includes(a.location_id))
  //     );
  //   } else {
  //     setFilteredAssets([]);
  //   }
  // };

  return (
    <>
      <ConfirmationDlg
        open={drawer}
        btnSubmitText={"Confirm"}
        btnCancelText={"Cancel"}
        onSubmit={confirmSignature}
        onClose={() => setDrawer(false)}
        hideSubmitBtn={isPermissionAllowed(allowedPermissions, selectedApp, [
          "edit people",
        ])}
      >
        <div className="container">
          <h4 className="text-center">Draw Signature in the white canvas</h4>
          <SignatureCanvas
            canvasProps={{ className: "canvaSig" }}
            ref={sigCanvas}
          />
          <div className="d-flex justify-content-between">
            <button className={"btn btn-theme text-black"} onClick={trim}>
              <i class="fa fa-image"></i> Crop Signature
            </button>
            <button className={"btn btn-theme  text-black"} onClick={clear}>
              <i class="fa fa-eraser"></i>Clear
            </button>
          </div>
          <div>
            {trimmedDataURL ? (
              <div
                style={{ position: "relative", textAlign: "center" }}
                className={"border border-1 border-theme p-2 mt-1"}
              >
                <h4>Signature Preview</h4>
                <img
                  style={{
                    filter: "invert(1)",
                    width: "70%",
                    bottom: "12px",
                  }}
                  alt="signature"
                  src={trimmedDataURL}
                />
              </div>
            ) : null}
          </div>
        </div>
      </ConfirmationDlg>
      <ConfirmationDlg
        open={open}
        size={"lg"}
        btnCancelText="Cancel"
        btnSubmitText={"Submit"}
        onSubmit={onSave}
        onClose={handleClose}
        hideSubmitBtn={
          !isPermissionAllowed(allowedPermissions, selectedApp, [
            "edit people",
          ]) && row?.username != username
        }
      >
        <h4>User</h4>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div className="my-2">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  m: "auto",
                }}
              >
                <div style={{}}>
                  <div style={{ px: 5, py: 4 }}>
                    <div style={{ mb: 4 }}>
                      <div className={"form-group mb-1"}>
                        <NormalInput
                          label={"Email"}
                          required={true}
                          value={email}
                          type="email"
                          onchange={(e) => {
                            setEmail(e.target.value.toLowerCase());
                          }}
                          name="email"
                        />
                      </div>
                      <div className={"form-group mb-2 phone-user"}>
                        <label
                          className="form-label"
                          style={{ minHeight: "15px" }}
                        >
                          Phone (Whatsapp)
                        </label>
                        <PhoneInput
                          international={true}
                          defaultCountry="SG"
                          value={phone}
                          onChange={setPhone}
                        />
                        <small>* For Alert Notification</small>
                      </div>
                      <div className={"form-group mb-1"}>
                        <NormalInput
                          label={"First Name"}
                          required={true}
                          value={firstname}
                          onchange={(e) => {
                            setFirstname(e.target.value);
                          }}
                          name="firstname"
                        />
                      </div>
                      <div className={"form-group mb-1"}>
                        <NormalInput
                          required={true}
                          value={lastname}
                          onchange={(e) => {
                            setLastname(e.target.value);
                          }}
                          name="lastname"
                          label={"Last Name"}
                        />
                      </div>
                      <div className={"form-group mb-1"}>
                        <NormalInput
                          required={true}
                          value={jobTitle}
                          onchange={(e) => {
                            setJobTitle(e.target.value);
                          }}
                          name="jobtitle"
                          label={"Job Title"}
                        />
                      </div>

                      <div className={"form-group mb-1"}>
                        <NormalInput
                          required={true}
                          value={password}
                          type="password"
                          onchange={(e) => {
                            setPassword(e.target.value);
                          }}
                          name="password"
                          label={"Password"}
                        />
                      </div>
                      <div className={"form-group mb-1"}>
                        <NormalSelect
                          label={"Customer"}
                          onchange={handleCustomerChange}
                          value={customer_id}
                          valueKey={"id"}
                          list={customers.map((f) => ({
                            id: f.id,
                            name: f.customer_name,
                          }))}
                        />
                      </div>

                      <PermissionChecker
                        permissions={["edit role"]}
                        hideIfNotAllowed
                      >
                        <div className={"form-group mb-1"}>
                          <NormalSelect
                            label={"User Role"}
                            onchange={handleRoleChange}
                            value={userRole}
                            valueKey={"id"}
                            list={userRoles.map((f) => ({
                              id: f.id,
                              name: f.rolename || f.name,
                            }))}
                            required
                          />
                        </div>
                      </PermissionChecker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <label>Your Signature</label>
            <div
              className={
                "signature border border-1 border-theme align-items-center p-3 mb-2"
              }
            >
              {signature ? (
                <img
                  style={{
                    filter: "invert(1)",
                    width: "70%",
                    bottom: "12px",
                  }}
                  src={signature}
                  alt={"signature"}
                />
              ) : (
                <div>
                  {firstname} {lastname}
                </div>
              )}
            </div>
            <hr />
            <div class="alert alert-info">
              <i class="fa fa-info"></i> You can customize the signature
            </div>
            <div class="d-flex justify-content-between">
              <button
                className="btn btn-theme  text-black"
                onClick={() => {
                  setDrawer(true);
                }}
              >
                Draw Signature
              </button>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setSignature(null);
                  setTrimmedDataURL(null);
                }}
              >
                Clear Custom Signature
              </button>
            </div>
          </div>
        </div>

        <Card>
          <CardHeader>Assigned Work Order Locations</CardHeader>
          <CardBody>
            <div>{renderLocations(locations, level)}</div>
          </CardBody>
        </Card>
      </ConfirmationDlg>
    </>
  );
}

export default ModalChangeUser;
